import { create } from 'zustand';

let counter = 0;

export const useToast = create((set, get) => ({
  toasts: [],
  push(toast) {
    const tone = toast.tone ?? 'default';
    // Dédup : un même message déjà affiché n'est pas réempilé (rafale d'erreurs realtime).
    const existing = get().toasts.find((t) => t.message === toast.message && t.tone === tone);
    if (existing) return existing.id;
    counter += 1;
    const id = `toast-${counter}`;
    const next = {
      id,
      tone: 'default',
      duration: 3200,
      ...toast,
    };
    // Cap à 3 : on garde les plus récents pour ne pas noyer l'écran.
    set({ toasts: [...get().toasts, next].slice(-3) });
    if (next.duration > 0) {
      setTimeout(() => get().dismiss(id), next.duration);
    }
    return id;
  },
  dismiss(id) {
    set({ toasts: get().toasts.filter((t) => t.id !== id) });
  },
  clear() {
    set({ toasts: [] });
  },
}));

export const toast = {
  success: (message, opts = {}) =>
    useToast.getState().push({ tone: 'success', message, ...opts }),
  error: (message, opts = {}) =>
    useToast.getState().push({ tone: 'error', message, ...opts }),
  info: (message, opts = {}) =>
    useToast.getState().push({ tone: 'info', message, ...opts }),
};
